<div class="row mb-3">
  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationTipper) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationTipper = !this.personalisationSettings.timelineOrientationTipper'
      >Tipper Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationTipper) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationTipper = !this.personalisationSettings.timelineOrientationTipper'
      >Tipper Timeline: Vertical</button>
    }
  </div>

  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationGrab) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationGrab = !this.personalisationSettings.timelineOrientationGrab'
      >Grab Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationGrab) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationGrab = !this.personalisationSettings.timelineOrientationGrab'
      >Grab Timeline: Vertical</button>
    }
  </div>

  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationConcrete) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationConcrete = !this.personalisationSettings.timelineOrientationConcrete'
      >Concrete Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationConcrete) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationConcrete = !this.personalisationSettings.timelineOrientationConcrete'
      >Concrete Timeline: Vertical</button>
    }
  </div>

  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationSweeper) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationSweeper = !this.personalisationSettings.timelineOrientationSweeper'
      >Sweeper Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationSweeper) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationSweeper = !this.personalisationSettings.timelineOrientationSweeper'
      >Sweeper Timeline: Vertical</button>
    }
  </div>

  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationShredder) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationShredder = !this.personalisationSettings.timelineOrientationShredder'
      >Shredding Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationShredder) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationShredder = !this.personalisationSettings.timelineOrientationShredder'
      >Shredding Timeline: Vertical</button>
    }
  </div>

  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationSkip) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationSkip = !this.personalisationSettings.timelineOrientationSkip'
      >Skips Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationSkip) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationSkip = !this.personalisationSettings.timelineOrientationSkip'
      >Skips Timeline: Vertical</button>
    }
  </div>

  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationArtic) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationArtic = !this.personalisationSettings.timelineOrientationArtic'
      >Artic Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationArtic) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationArtic = !this.personalisationSettings.timelineOrientationArtic'
      >Artic Timeline: Vertical</button>
    }
  </div>
  <div class="col-md-4 content-block">
    @if (this.personalisationSettings.timelineOrientationTanker) {
      <button
        class='btn btn-block btn-primary'
        (click)='this.personalisationSettings.timelineOrientationTanker = !this.personalisationSettings.timelineOrientationTanker'
      >Tanker Timeline: Horizontal</button>
    }
    @if (!this.personalisationSettings.timelineOrientationTanker) {
      <button
        class='btn btn-block btn-info'
        (click)='this.personalisationSettings.timelineOrientationTanker = !this.personalisationSettings.timelineOrientationTanker'
      >Tanker Timeline: Vertical</button>
    }
  </div>
</div>
